import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";
import { Case } from "./case";
import { Worker } from "../../workers/_types/worker";
import { User } from "../../users/_types/user";
import { ThirdParty } from "../../transactions/_types/third-party";

export class CaseIncident extends Resource {
    public override type = 'caseIncidents';

    @prop()
    @required()
    public date: Date = new Date();

    @prop()
    @required()
    public source: string = "Worker";

    @prop()
    @required()
    public caseId!: string;

    public case!: Case;

    @prop()
    @required()
    public thirdPartyId!: string;

    public thirdParty!: ThirdParty;

    @prop()
    @required()
    public incidentTypeId!: string;

    public incidentType!: Client;

    @prop()
    public userId!: string;

    public user!: User;

    @prop()
    @required()
    public description!: string;

    @prop()
    public isApplicable?: boolean;
}